module.exports = __webpack_public_path__ + "static/media/R-PANELv6.5-RC1/chevronDownBlack.0498bbd0.svg";